export default "__VITE_ASSET__FJ7w2ScN3fXgpmI7X7BK5g__"